import './AccessorialsAndFeesActiveRates.css';
import React from 'react';
import TerminalSelector from '../../containers/TerminalSelector';
import Waitable from '../Waitable';
import OrganizationSelector from '../../containers/OrganizationSelector';
import COLUMNS from './table_columns';
import TableV2 from '../Table/TableV2';
import { Row, Input, Col, Label, FormGroup } from 'reactstrap';
import NotesForm from './NotesForm';
import { toast } from 'react-toastify';



export default class AccessorialsAndFeesActiveRates extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      clientObject: undefined,
      displayClientRates: false,
      disableClientSelector: true
    };

    this.onOrgChange = this.onOrgChange.bind(this);
    this.getNote = this.getNote.bind(this);
    this.getFuelSurcharge = this.getFuelSurcharge.bind(this);
    this.onTerminalChange = this.onTerminalChange.bind(this);
    this.getAccessorialData = this.getAccessorialData.bind(this);
    this.onViewClientRates = this.onViewClientRates.bind(this);
    this.onSubmitNote = this.onSubmitNote.bind(this);
  }

  getFuelSurcharge(terminalId){
    let { accessorials } = this.props;
    accessorials = accessorials.get('data');
    // filter it out
    if (!accessorials) return [];
    accessorials = accessorials.filter(accessorial => accessorial.terminalId === terminalId);
    if (accessorials.length === 1) {
      return accessorials[0]["Fuel Surcharge"];
    }

  }
  getNote(terminalId) {
    let { accessorials } = this.props;
    accessorials = accessorials.get('data');
    // filter it out
    if (!accessorials) return [];
    accessorials = accessorials.filter(accessorial => accessorial.terminalId === terminalId);
    if (accessorials.length === 1) {
      return accessorials[0].Note;
    }

  }
  getAccessorialData(terminalId) {
    let { accessorials } = this.props;
    accessorials = accessorials.get('data');
    // filter it out
    if (!accessorials) return [];
    accessorials = accessorials.filter(accessorial => accessorial.terminalId === terminalId);

    let accessorialsData = [];
    if (accessorials.length === 1) {
      let calc = (_entries, text) => {
        _entries.forEach(entry => {
          if (entry[1]) {
            if (Object.prototype.hasOwnProperty.call(entry[1], "rate")) {
              accessorialsData.push({
                accessorial: text ? text + "." + entry[0] : entry[0],
                rate: entry[1].rate,
                baseRate: entry[1].baseRate,
              });
            } else if (typeof entry[1] === 'object') {
              calc(Object.entries(entry[1]), entry[0]);
            }
          }
        });
      };

      let entries = Object.entries(accessorials[0]);
      calc(entries);
    }
    return accessorialsData;
  }

  onTerminalChange(terminalObject) {
    let { dispatchSetUiState } = this.props;
    dispatchSetUiState({
      terminalObject
    });
  }

  onOrgChange(clientObject) {
    const { dispatchSetUiState, dispatchGetAccessorials } = this.props;
    dispatchSetUiState({
      clientObject
    });
    dispatchGetAccessorials({
      orgId: clientObject.value
    });
  }

  onViewClientRates(ev) {
    this.setState({
      displayClientRates: ev.target.checked,
      disableClientSelector: !ev.target.checked
    }, () => {
      const { dispatchGetAccessorials } = this.props;
      dispatchGetAccessorials();
    });
  }

  onSubmitNote(note) {
    const { dispatchUpdateAccessorial } = this.props;
    let { disableClientSelector } = this.state;
    let { uiState, dispatchSetUiState, accessorials, importAccessorials } = this.props;
    let { clientObject, terminalObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    const { dispatchGetAccessorials } = this.props;
    let orgId = clientObject ? clientObject.value : null

    if (note.notes && note.notes.length > 0) {
      dispatchUpdateAccessorial({
        query: {
          operator: "NOTE",
          note: note.notes
        },
        terminalId: terminalId,
        orgId

      }, (err, result) => {
        if (err) {
          toast.error(err.message);
        } else {
          toast.success(result.Note);

          dispatchGetAccessorials();
        }

      });
    } else {
      dispatchUpdateAccessorial({
        query: {
          operator: "FUEL",
          fuel: parseInt(note.fuelSurcharge)
        },
        terminalId: terminalId,
        orgId

      }, (err, result) => {
        if (err) {
          toast.error(err.message);
        } else {
          toast.success(result["Fuel Surcharge"]);

          dispatchGetAccessorials();
        }

      });
    }
  }


  render() {
    let { disableClientSelector } = this.state;
    let { uiState, dispatchSetUiState, accessorials, importAccessorials } = this.props;
    let { clientObject, terminalObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let notes = this.getNote(terminalId);
    let fuel = this.getFuelSurcharge(terminalId);

    return (

      <Row>
        <Col xs='12'>
          <Label>Terminal</Label>
        </Col>
        <Col xs='12' className="pb-3">
          <TerminalSelector
            value={terminalObject}
            terminalId={terminalId}
            onChange={this.onTerminalChange} />
        </Col>
        {terminalId ?
          <Col>
            <Col xs='12' className="pb-3">
              <FormGroup check className="checkbox pt-2">
                <Input onClick={this.onViewClientRates} className="form-check-input" type="checkbox" id="checkbox1" name="checkbox1" value="option1" />
                <Label check className="form-check-label" htmlFor="checkbox1">View Client Rates</Label>
              </FormGroup>
            </Col>

            {disableClientSelector ? null :
              <div>
                <Col xs='12'>
                  <Label>Client</Label>
                </Col>
                <Col xs='12' className="pb-3">
                  <OrganizationSelector
                    terminalId={terminalId}
                    disabled={disableClientSelector}
                    value={clientObject}
                    onChange={this.onOrgChange}
                  />
                </Col>
              </div>
            }

            <Col xs='12' className="pb-3">
              <Waitable className="mb-3" entities={[accessorials, importAccessorials]}>
                <NotesForm
                  onSubmit={this.onSubmitNote}
                  notes={notes}
                  fuel={fuel + "%"}
                />
              </Waitable>
            </Col>

            <Col xs='12'>

              <Waitable entities={[accessorials, importAccessorials]}>

                <TableV2
                  data={this.getAccessorialData(terminalId)}
                  columns={COLUMNS.accessorialDataColumns}
                  uiState={uiState}
                  dispatchSetUiState={dispatchSetUiState}
                />

              </Waitable>

            </Col>
          </Col>
          : null
        }
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AccessorialsAndFees/AccessorialsAndFeesActiveRates.js